// Real Airbnb reviews, transcribed verbatim from the listing (5-star only).
// Single source of truth for guest reviews + the derived rating figures.
// Consumed by home, book, and the SEO landing pages — never hardcode
// rating/review-count numbers elsewhere; import REVIEW_AVG / REVIEW_COUNT.
export type GuestReview = {
  name: string;
  location: string;
  date: string;
  rating: number;
  text: string;
  trip: string;
};

export const REVIEWS: GuestReview[] = [
  {
    name: "Jeffrey",
    location: "Saint Paul, Indiana",
    date: "June 2026",
    rating: 5,
    text: "We had a wonderful stay at this cabin on Lake Miltona! From the moment we arrived, it was clear the owners take great pride in their property. The cabin was very clean, the woodworking throughout is beautiful, and the location and lake views are absolutely outstanding. We especially enjoyed the comfortable seating upstairs, the easy access to the boat dock for family and visitors, the reliable Wi-Fi, and the unique table with the embossed wildlife—it was such a neat conversation piece and really added to the character of the cabin. The owners were exceptional hosts. We only had a couple of questions during our stay, and they responded almost immediately each time. Their communication and willingness to help made the entire experience even better.",
    trip: "Stayed with a pet",
  },
  {
    name: "Sean",
    location: "Minneapolis, Minnesota",
    date: "June 2026",
    rating: 5,
    text: "Our group really enjoyed our stay at Samantha's cabin. The place has everything to offer for a bigger group, as well as space for everyone. Between the pool table, multiple grills including a blackstone, sauna, beautiful beach, and two porches…it had everything we could ask for. Host was very responsive and willing to answer any questions we had. They've done a wonderful job with the place, and I'd recommend to anyone for a fun time up north!",
    trip: "Group trip",
  },
  {
    name: "Jane",
    location: "Minneapolis, Minnesota",
    date: "June 2026",
    rating: 5,
    text: "My friends and I had a great girls' weekend at this cabin. It exceeded our expectations. It was clean, cozy, and had a nice cabin feel. The sleeping arrangements were comfortable and everyone had a nice place to sleep. Even though the weather wasn't ideal, we enjoyed exploring local spots, relaxing at the cabin, and using the sauna. Samantha was very helpful, responsive, and easy to communicate with. We highly recommend staying here!",
    trip: "Group trip",
  },
  {
    name: "Faith",
    location: "Airbnb Guest",
    date: "June 2026",
    rating: 5,
    text: "Samantha and her husband Jake as well as Julie were very kind and helpful. The place was very clean. We loved how close the beach was and the outdoor shower was great. The Blackstone and grill were in excellent condition and we enjoyed getting to utilize them. During our stay we lost power due to a strong wind storm and Samantha and Jake were very understanding and made things more than right.",
    trip: "Stayed with kids",
  },
  {
    name: "Matthew",
    location: "Airbnb Guest",
    date: "May 2026",
    rating: 5,
    text: "My favorite parts was the beach, pool table, and games.  One thing that was super convenient was that after we were done with the beach there was a beautiful outdoor shower. Overall, our stay was fantastic and would definitely recommend!",
    trip: "Group trip",
  },
  {
    name: "Kim",
    location: "Minneapolis, Minnesota",
    date: "July 2025",
    rating: 5,
    text: "Beautiful cabin!",
    trip: "Stayed with kids",
  },
  {
    name: "Cindy",
    location: "Airbnb Guest",
    date: "July 2025",
    rating: 5,
    text: "This is a great rental. The beach is remarkable — super sandy, very shallow. Would rent again!",
    trip: "Group trip",
  },
  {
    name: "Jonathan",
    location: "Airbnb Guest",
    date: "September 2024",
    rating: 5,
    text: "The house was set up well for 12 people to enjoy a long weekend and not feel crowed. Lots of seating and areas for people to separate. The beach was sandy and very well kept just like the rest of the property.",
    trip: "Group trip",
  },
  {
    name: "Jacob",
    location: "Airbnb Guest",
    date: "August 2024",
    rating: 5,
    text: "Had a fantastic time, everything was even better than expected! Great host, very happy with the experience.",
    trip: "Group trip",
  },
  {
    name: "Troy",
    location: "Luverne, Minnesota",
    date: "July 2024",
    rating: 5,
    text: "Our party had a great time! The cabin was large and accommodated our group of 14 easily.  The view of the lake was amazing.  Our kids loved the great sandy shore and the large, shallow (2-4 feet) area of water to swim in!  The hosts had terrific communication with us.  We had a wonderful time even though our stay was just for the weekend!",
    trip: "Stayed with kids",
  },
  {
    name: "Judith",
    location: "Coon Rapids, Minnesota",
    date: "July 2024",
    rating: 5,
    text: "It was everything we expected.  The lake was just perfect for the kids.. they really liked the extra large paddle board. Comfortable beds and pillows.   We really appreciated the well stocked bathrooms and kitchen.  Jake is the perfect host.  He responds very quickly.  The only complaint is we wished we could have stayed longer.",
    trip: "Stayed with kids",
  },
  {
    name: "Jay",
    location: "Airbnb Guest",
    date: "July 2024",
    rating: 5,
    text: "The perfect place for a family vacation! The cabin was beautiful and full of unexpected amenities, including new kitchen appliances and a new Blackstone outdoor grill. The setting was amazing, with a large, clean, perfectly groomed sandy beach and fire pit. The clear, weedless water and gently sloping, sandy lake bottom made for safe and enjoyable swimming for children and adults of all ages. Even the boat launch was conveniently located just a couple of minutes away, and it was large and uncrowded, even on a holiday weekend! The hosts were extremely responsive to every question and need and made our stay a very special family event.",
    trip: "Stayed with kids",
  },
  {
    name: "Kimberly",
    location: "Airbnb Guest",
    date: "July 2024",
    rating: 5,
    text: "Our whole family had a great week! We loved the beach and the fact it was a nice shallow beach for our kids to enjoy! Jake was great about communicating with us if we had questions through out the stay!",
    trip: "Stayed with kids",
  },
  {
    name: "Alex",
    location: "Waseca, Minnesota",
    date: "June 2024",
    rating: 5,
    text: "Great host very responsive and wonderful cabin.",
    trip: "Group trip",
  },
  {
    name: "Amanda",
    location: "Omaha, Nebraska",
    date: "June 2024",
    rating: 5,
    text: "The hospitality from Jake really stood out for this Air BnB. 10/10 we will be back!",
    trip: "Stayed with kids",
  },
  {
    name: "Patrick",
    location: "Airbnb Guest",
    date: "May 2024",
    rating: 5,
    text: "The cabin was exactly as described and the photos were a good depiction of the cabin. The location of the cabin on the lake was very nice, a couple blocks from the boat landing, naturally sandy beach, excellent fishing and recreation lake. The cabin had great amenities and new kitchen appliances. There was ample sleeping areas that were isolated enough that people who wanted to sleep in the rooms could do so in peace, and people who wanted to be social could do so without worrying about disturbing others. It was a very nice cabin!",
    trip: "Stayed with a pet",
  },
  {
    name: "James",
    location: "Woodbury, Minnesota",
    date: "May 2024",
    rating: 5,
    text: "The cabin was just as advertised.  Really nice swim area for the little kids.  Easy access to get our boat in and out.  Very clean.  Plenty of room for the six of us.",
    trip: "Stayed with kids",
  },
  {
    name: "Yevgeniy",
    location: "Wayzata, Minnesota",
    date: "March 2024",
    rating: 5,
    text: "This cabin is a great getaway from the city life. Located on the lake shore and everything you see on the pictures is what you will see in reality. Great host, wonderful communication. Would come back to this cabin in the future.",
    trip: "Group trip",
  },
  {
    name: "Tracey",
    location: "Orlando, Florida",
    date: "December 2023",
    rating: 5,
    text: "I have never felt more at home. Most Airbnb's have that \"somebody else's house\" feel. This place I felt like I was staying at my own family's cabin. My kids are 25, 21, and 18. They ran around the house like little kids again. They were so excited. The pictures don't do this place justice! The 3 story cabin is just beautiful!! We came near Christmas so they decorated the place for us! We were so happy to see the beautiful tree and so many Christmas things! The house kept us very entertained at night. The lake was frozen and just beautiful so we build a fire on the beach. We had pool tournaments in the 1st floor bar. We were all able to watch football and movies at the same time (2 large living rooms). The kids loved the sauna. I loved the fact that the kitchen had spices and random non-perishable items (that were probably left from previous guests) as I love to cook. I made a homemade meal every night easily as there was everything I needed. I could go on and on! Highly recommend!!",
    trip: "Group trip",
  },
  {
    name: "Nicole",
    location: "Saint Paul, Minnesota",
    date: "November 2023",
    rating: 5,
    text: "This was a great place with an excellent host! The cabin has one of the best sandy beaches and lakeviews around. There was plenty of space and sleeping options. The living room was cozy and there was plenty of easy cooking and eating space. The host was so friendly and responsive throughout the weekend - and had a great winery recommendation. We are already planning our next trip!",
    trip: "Stayed with a pet",
  },
  {
    name: "Pam",
    location: "Andover, Minnesota",
    date: "November 2023",
    rating: 5,
    text: "We enjoyed our stay at this beautiful place and had a wonderful time with our family.  Loved everything about this place, the log cabin interior, the downstairs was a fun place to play games, had a pool table and looked right out to the lake, the sleeping areas, kitchen, living room was great.  Everything was perfect with check in - it was an in person check in which was awesome so we could do the walk through and he answered any questions.  Best communication ever - always available to respond to questions before the trip during and after.  We highly recommend this place, we hope to visit again in the summer when we can enjoy some of the outside amenities!!!",
    trip: "Stayed with kids",
  },
  {
    name: "Lisa",
    location: "Airbnb Guest",
    date: "October 2023",
    rating: 5,
    text: "Beautiful location. We really enjoyed our mini family vacation. House had all we needed and the hosts were great. There were treats when we arrived and we saw 4 eagles fly right by us as we enjoyed our morning coffee. Beautiful sandy beach and outdoor areas as well. Easy access. Highly recommend. Hoping to go back for the summer season.",
    trip: "Stayed with a pet",
  },
  {
    name: "Brad",
    location: "Bloomington, Minnesota",
    date: "October 2023",
    rating: 5,
    text: "The log cabin on Lake Miltona is a wondeful place to vacation.  Our family had a great time and was greeted with treats for our kids and a beautiful view of the lake.  If you like rustic log cabins you will like this place.  The cabin was clean, neat, and had everything you need to enjoy yourself.  We especially enjoyed the sand beach, pool table, and lounging by the fire table.  There are lots of fun things to do in the area and the host made some excellent recommendations.  I have no doubt that we will be back again soon.",
    trip: "Stayed with a pet",
  },
  {
    name: "Carolyn",
    location: "Airbnb Guest",
    date: "September 2023",
    rating: 5,
    text: "We really enjoyed our stay at Jake's cabin.  The two decks provided a beautiful view of the lake and we especially appreciated the level walk out to the sandy beach for swimming, sunning and sitting around the fire pit in the evening. We hope to rent the cabin next year for a large family gathering and the beach will be a big plus for the kids.  The cabin is very comfortable and can easily accommodate 12 both for eating and sleeping. Jake was very responsive to our questions prior to our stay.  We didn't really have any questions or concerns during our stay.  We definitely recommended this cabin.  Enjoy!",
    trip: "Stayed a few nights",
  },
  {
    name: "Connor",
    location: "New Prague, Minnesota",
    date: "August 2023",
    rating: 5,
    text: "Jake was a great host for me and my group. He was very fast on replying if I had questions and gave us some great recommendations on things to do in the area. The location was perfect with sandy waters right out the back door. Everything was neat and clean when we arrived. This place is great for a group of people looking to get together. I would highly recommend using Jake as your host!",
    trip: "Group trip",
  },
];

export const REVIEW_COUNT = REVIEWS.length;
export const REVIEW_AVG = (REVIEWS.reduce((s, r) => s + r.rating, 0) / REVIEWS.length).toFixed(1);

// Short, punchy quote surfaced at the payment step for trust reinforcement.
// Falls back to the first review if the pick is ever removed from the list.
export const CHECKOUT_QUOTE = REVIEWS.find((r) => r.name === "Cindy") ?? REVIEWS[0];
